import { useEffect } from "react";
import { SelectInput, required } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { CourseChoices, SemestersChoices } from "utils/choices";
import { useCurriculum } from "../CurriculumContext";
import { GridItem } from "./Partials";

// Each course holds two semesters; a half year of study leaves the last course with one.
const ElectiveGroupScheduleFields = () => {
  const curriculum = useCurriculum();
  const { setValue } = useFormContext();

  const course = useWatch({ name: "course" });
  const semester = useWatch({ name: "semester" });

  const yearsOfStudy = curriculum?.yearsOfStudy ?? 0;
  const maxSemester = Math.ceil(yearsOfStudy * 2);

  const courseChoices = CourseChoices.filter(choice => choice.id <= Math.ceil(yearsOfStudy));
  const semesterChoices = course
    ? SemestersChoices.filter(choice => choice.id >= course * 2 - 1 && choice.id <= Math.min(course * 2, maxSemester))
    : [];
  const isSemesterValid = semesterChoices.some(choice => choice.id === semester);

  useEffect(() => {
    if (semester != null && !isSemesterValid) {
      setValue("semester", null);
    }
  }, [setValue, semester, isSemesterValid]);

  return (
    <>
      <GridItem md={6}>
        <SelectInput
          source="course"
          label="Курс"
          choices={courseChoices}
          fullWidth
          validate={required("Полето е задължително.")}
        />
      </GridItem>
      <GridItem md={6}>
        <SelectInput
          source="semester"
          label="Семестър"
          choices={semesterChoices}
          fullWidth
          disabled={!course}
          helperText={course ? undefined : "Изберете курс"}
          validate={required("Полето е задължително.")}
        />
      </GridItem>
    </>
  );
};

export default ElectiveGroupScheduleFields;
